import type { Consumer } from '~/constants/common/consumer';
import { COMPOSER_OPEN_PARAM } from '~/constants/composer';
import type { AppliedFilters } from '~/contracts/common';
import { getHrefWithSource } from '~/hooks/common/selectors/useGetConsumerHref';
import buildSearchLink from '~/utilities/composer/buildSearchLink';

export type ComposerSearchInput =
  | { cvnaid: string }
  | { filters: Partial<AppliedFilters> };

export default function buildComposerRedirectUrl(
  consumer: Consumer,
  input: ComposerSearchInput,
  { reopenComposer = false }: { reopenComposer?: boolean } = {}
): string {
  const searchLink = buildSearchLink(input);
  const href = getHrefWithSource(consumer)(searchLink);

  if (!reopenComposer) return href;

  const [pathname, search = ''] = href.split('?');
  const params = new URLSearchParams(search);
  params.set(COMPOSER_OPEN_PARAM, '1');

  return `${pathname}?${params}`;
}
